// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file dev/moment/page/v1alpha1/authority.proto (package dev.moment.page.v1alpha1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Struct } from "@bufbuild/protobuf";

/**
 * @generated from message dev.moment.page.v1alpha1.PageAuthority
 */
export class PageAuthority extends Message<PageAuthority> {
  /**
   * *
   * The initial document state passed in on initialization. THIS FIELD IS POORLY NAMED.
   *
   * @generated from field: optional google.protobuf.Struct doc = 1;
   */
  doc?: Struct;

  /**
   * *
   * A "hot" list of ~100 or so commits. When this list gets too large, we checkpoint the
   * document state, truncate this list, and store the old steps in cold storage.
   *
   * @generated from field: repeated dev.moment.page.v1alpha1.Commit commits = 3;
   */
  commits: Commit[] = [];

  /**
   * * Whether the document has been archived. 
   *
   * @generated from field: bool archived = 4;
   */
  archived = false;

  /**
   * *
   * A mutex variable we use to ensure that only one infinite-running `checkpoint` workflow runs
   * at a time.
   *
   * @generated from field: bool running_checkpoint_loop = 5;
   */
  runningCheckpointLoop = false;

  /**
   * * The version of the last commit that was checkpointed to the cold storage `SortedMap`. 
   *
   * @generated from field: double last_checkpointed_version = 6;
   */
  lastCheckpointedVersion = 0;

  constructor(data?: PartialMessage<PageAuthority>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.PageAuthority";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "doc", kind: "message", T: Struct, opt: true },
    { no: 3, name: "commits", kind: "message", T: Commit, repeated: true },
    { no: 4, name: "archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "running_checkpoint_loop", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "last_checkpointed_version", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PageAuthority {
    return new PageAuthority().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PageAuthority {
    return new PageAuthority().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PageAuthority {
    return new PageAuthority().fromJsonString(jsonString, options);
  }

  static equals(a: PageAuthority | PlainMessage<PageAuthority> | undefined, b: PageAuthority | PlainMessage<PageAuthority> | undefined): boolean {
    return proto3.util.equals(PageAuthority, a, b);
  }
}

/**
 * A `Commit` is a collection of prosemirror `step`s from a specific `client`.
 *
 * @generated from message dev.moment.page.v1alpha1.Commit
 */
export class Commit extends Message<Commit> {
  /**
   * See prosemirror `Step` type.
   *
   * @generated from field: repeated google.protobuf.Struct steps = 1;
   */
  steps: Struct[] = [];

  /**
   * A unique ref identifying this commit.
   *
   * @generated from field: string ref = 2;
   */
  ref = "";

  /**
   * @generated from field: double version = 3;
   */
  version = 0;

  constructor(data?: PartialMessage<Commit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.Commit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "steps", kind: "message", T: Struct, repeated: true },
    { no: 2, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Commit {
    return new Commit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Commit {
    return new Commit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Commit {
    return new Commit().fromJsonString(jsonString, options);
  }

  static equals(a: Commit | PlainMessage<Commit> | undefined, b: Commit | PlainMessage<Commit> | undefined): boolean {
    return proto3.util.equals(Commit, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.InitializeRequest
 */
export class InitializeRequest extends Message<InitializeRequest> {
  /**
   * See prosemirror `Node` type which is used to represent a "doc".
   *
   * @generated from field: optional google.protobuf.Struct doc = 1;
   */
  doc?: Struct;

  constructor(data?: PartialMessage<InitializeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.InitializeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "doc", kind: "message", T: Struct, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitializeRequest {
    return new InitializeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitializeRequest {
    return new InitializeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitializeRequest {
    return new InitializeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InitializeRequest | PlainMessage<InitializeRequest> | undefined, b: InitializeRequest | PlainMessage<InitializeRequest> | undefined): boolean {
    return proto3.util.equals(InitializeRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.InitializeResponse
 */
export class InitializeResponse extends Message<InitializeResponse> {
  constructor(data?: PartialMessage<InitializeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.InitializeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitializeResponse {
    return new InitializeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitializeResponse {
    return new InitializeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitializeResponse {
    return new InitializeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InitializeResponse | PlainMessage<InitializeResponse> | undefined, b: InitializeResponse | PlainMessage<InitializeResponse> | undefined): boolean {
    return proto3.util.equals(InitializeResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.PageRequest
 */
export class PageRequest extends Message<PageRequest> {
  constructor(data?: PartialMessage<PageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.PageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PageRequest {
    return new PageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PageRequest {
    return new PageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PageRequest {
    return new PageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PageRequest | PlainMessage<PageRequest> | undefined, b: PageRequest | PlainMessage<PageRequest> | undefined): boolean {
    return proto3.util.equals(PageRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.PageResponse
 */
export class PageResponse extends Message<PageResponse> {
  /**
   * @generated from field: google.protobuf.Struct doc = 1;
   */
  doc?: Struct;

  /**
   * @generated from field: double version = 2;
   */
  version = 0;

  constructor(data?: PartialMessage<PageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.PageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "doc", kind: "message", T: Struct },
    { no: 2, name: "version", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PageResponse {
    return new PageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PageResponse {
    return new PageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PageResponse {
    return new PageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PageResponse | PlainMessage<PageResponse> | undefined, b: PageResponse | PlainMessage<PageResponse> | undefined): boolean {
    return proto3.util.equals(PageResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.ApplyRequest
 */
export class ApplyRequest extends Message<ApplyRequest> {
  /**
   * @generated from field: dev.moment.page.v1alpha1.Commit commit = 1;
   */
  commit?: Commit;

  constructor(data?: PartialMessage<ApplyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.ApplyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "commit", kind: "message", T: Commit },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ApplyRequest {
    return new ApplyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ApplyRequest {
    return new ApplyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ApplyRequest {
    return new ApplyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ApplyRequest | PlainMessage<ApplyRequest> | undefined, b: ApplyRequest | PlainMessage<ApplyRequest> | undefined): boolean {
    return proto3.util.equals(ApplyRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.ApplyResponse
 */
export class ApplyResponse extends Message<ApplyResponse> {
  /**
   * @generated from field: dev.moment.page.v1alpha1.Commit commit = 1;
   */
  commit?: Commit;

  constructor(data?: PartialMessage<ApplyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.ApplyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "commit", kind: "message", T: Commit },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ApplyResponse {
    return new ApplyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ApplyResponse {
    return new ApplyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ApplyResponse {
    return new ApplyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ApplyResponse | PlainMessage<ApplyResponse> | undefined, b: ApplyResponse | PlainMessage<ApplyResponse> | undefined): boolean {
    return proto3.util.equals(ApplyResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.ChangesRequest
 */
export class ChangesRequest extends Message<ChangesRequest> {
  /**
   * @generated from field: double since_version = 1;
   */
  sinceVersion = 0;

  constructor(data?: PartialMessage<ChangesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.ChangesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "since_version", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangesRequest {
    return new ChangesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangesRequest {
    return new ChangesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangesRequest {
    return new ChangesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangesRequest | PlainMessage<ChangesRequest> | undefined, b: ChangesRequest | PlainMessage<ChangesRequest> | undefined): boolean {
    return proto3.util.equals(ChangesRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.ChangesResponse
 */
export class ChangesResponse extends Message<ChangesResponse> {
  /**
   * @generated from field: repeated dev.moment.page.v1alpha1.Commit commits = 2;
   */
  commits: Commit[] = [];

  constructor(data?: PartialMessage<ChangesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.ChangesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "commits", kind: "message", T: Commit, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangesResponse {
    return new ChangesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangesResponse {
    return new ChangesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangesResponse {
    return new ChangesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangesResponse | PlainMessage<ChangesResponse> | undefined, b: ChangesResponse | PlainMessage<ChangesResponse> | undefined): boolean {
    return proto3.util.equals(ChangesResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.ArchiveRequest
 */
export class ArchiveRequest extends Message<ArchiveRequest> {
  constructor(data?: PartialMessage<ArchiveRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.ArchiveRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveRequest {
    return new ArchiveRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveRequest {
    return new ArchiveRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveRequest {
    return new ArchiveRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveRequest | PlainMessage<ArchiveRequest> | undefined, b: ArchiveRequest | PlainMessage<ArchiveRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.ArchiveResponse
 */
export class ArchiveResponse extends Message<ArchiveResponse> {
  constructor(data?: PartialMessage<ArchiveResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.ArchiveResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveResponse {
    return new ArchiveResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveResponse {
    return new ArchiveResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveResponse {
    return new ArchiveResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveResponse | PlainMessage<ArchiveResponse> | undefined, b: ArchiveResponse | PlainMessage<ArchiveResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.CheckpointRequest
 */
export class CheckpointRequest extends Message<CheckpointRequest> {
  constructor(data?: PartialMessage<CheckpointRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.CheckpointRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckpointRequest {
    return new CheckpointRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckpointRequest {
    return new CheckpointRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckpointRequest {
    return new CheckpointRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckpointRequest | PlainMessage<CheckpointRequest> | undefined, b: CheckpointRequest | PlainMessage<CheckpointRequest> | undefined): boolean {
    return proto3.util.equals(CheckpointRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.page.v1alpha1.CheckpointResponse
 */
export class CheckpointResponse extends Message<CheckpointResponse> {
  constructor(data?: PartialMessage<CheckpointResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.page.v1alpha1.CheckpointResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckpointResponse {
    return new CheckpointResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckpointResponse {
    return new CheckpointResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckpointResponse {
    return new CheckpointResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckpointResponse | PlainMessage<CheckpointResponse> | undefined, b: CheckpointResponse | PlainMessage<CheckpointResponse> | undefined): boolean {
    return proto3.util.equals(CheckpointResponse, a, b);
  }
}

